<template>
    <div>
        <div class="tips">
            <img src="@/assets/examVideoV2/icon_wxtstb@2x.png">
            <p>温馨提示：购买考场视频后可查看您所选择的单个考场下包含的所有路线视频，请选择正确的考场进行购买哦~</p>
        </div>
        <div class="category">
            <h3 @click="cityStatus = true">科三考场</h3>
            <p>请选择您的考场</p>
            <div class="city">
                <div class="city-item" :class="{active: item.cityCode === currentCategory.cityCode}" v-for="(item) in categoryItems" :key="item.cityCode" @click="handleToggleCity(item.cityCode)">
                    <span>{{item.cityName}}</span>
                </div>
            </div>
            <div class="wrap">
                <div v-for="(item) in currentCategory.examPlaceList" :key="item.id" class="item" @click="jumpPage(item.id)">
                    <img :src="item.reduceUrl">
                    <img class="item-type" :src=" item.vipFlag ? require('@/assets/examVideoV2/icon_ykt@2x.png') : require('@/assets/examVideoV2/icon_wkt@2x.png')">
                    <div class="content">
                        <div class="item-name">{{item.name}}</div>
                        <div class="item-count">共<span>{{item.count}}</span>条路线</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ActionSheet, Button, Toast } from 'vant'
export default {
    name: 'vipCoachGoodsVideoCategory',
    components: {
        [ActionSheet.name]: ActionSheet,
        [Button.name]: Button
    },
    data () {
        return {
            cityCode: '',
            currentCategory: {},
            categoryItems: []
        }
    },
    methods: {
        // 切换城市
        handleToggleCity (cityCode) {
            this.$store.dispatch('vipCoach/setGzhExamVideoV2', { cityCode, examPlaceBatchId: '' })
            this.getCategory(cityCode)
        },
        // 获取分类
        getCategory (cityCode) {
            const phone = localStorage.getItem('gzh-coach-userphone')
            this.cityCode = cityCode
            this.$api.getExamPlaceList({
                subject: 3,
                cityCode: this.cityCode,
                phone
            }, 'gzh').then(res => {
                if (res.status) {
                    const arr = res.result.examPlaceList
                    if (arr && arr.length) {
                        this.currentCategory = arr.find(({ cityCode }) => (cityCode === this.cityCode)) || arr[0]
                        this.categoryItems = arr
                    }
                } else {
                    Toast(res.message)
                }
            })
        },
        // 跳转
        jumpPage (id) {
            console.log(id)
            this.$router.replace({
                name: 'vipCoachGoodsIndex',
                query: {
                    ...this.$route.query,
                    cityCode: this.currentCategory.cityCode,
                    examPlaceBatchId: id
                }
            })
        }
    },
    activated () {
        // 切换过城市就用切换的城市
        const gzhExamVideoV2 = this.$store.getters['vipCoach/getGzhExamVideoV2']
        const cityCode = gzhExamVideoV2.cityCode || this.$route.query.cityCode
        this.getCategory(cityCode)
    }
}
</script>
<style lang="scss" scoped>
*{
    box-sizing: border-box;
}
img{
    width: 100%;

}
.tips{
    display: flex;
    align-items: flex-start;
    padding: 5px 15px;
    color: #666;
    background-color: #FEF7EF;
    img {
        margin-right: 4px;
        width: 12px;
        height: 12px;
    }
    p {
        font-size: 12px;
        line-height: 19px;
    }
}
.category{
    padding: 30px 20px;
    text-align: center;
    color:#333;
    font-size: 14px;
    line-height: 1;
    h3{
        font-size: 24px;
        font-weight: 600;
    }
    p{
        margin-top: 10px;
        color:#999;
    }
    .wrap{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item{
            margin-bottom: 15px;
            position: relative;
            width: 160px;
            height: 100px;
            overflow: hidden;
            border-radius: 5px;
            &::before{
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,0.5);
            }
            img{
                height: 100%;
                object-fit: cover;
            }
            .content{
                position: absolute;
                z-index: 2;
                top:50%;
                left: 50%;
                color:#fff;
                transform: translate(-50%, -50%);
                .item-name{
                    font-size: 15px;
                }
                .item-count{
                    margin-top: 5px;
                    font-size: 12px;
                    span{
                        color: red;
                    }
                }
            }
            .item-type{
                position: absolute;
                top: 0;
                right: 0;
                width: 52px;
                height: 16px;
            }
        }
    }
}
.city{
    padding: 20px 10px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
    .city-item{
        color:#333;
        font-size: 15px;
        margin:0 15px 20px;
        transition: all 0.5s ease;
        transform-origin: center;
        &.active{
            position: relative;
            font-weight: 600;
            transform: scale(1.05);
            &::before{
                content:'';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 5px;
                background-color: #53cb85;
                border-radius: 5px;
            }
            span{
                position: relative;
            }
        }
    }
}
</style>
